import type { Store } from '../../../store/list/types';

/**
 * De-select all selected recordings.
 */
export const deselectAllRecordings = (store: Store): void => {
  const {
    recordings,
    selectedRecordings,
    setSelectedRecordings,
    setSelectedAllRecordings,
    setRecordings,
  } = store.getState();

  setSelectedAllRecordings(false);

  if (selectedRecordings.length > 0) {
    setSelectedRecordings([]);

    recordings.forEach((recording) => (recording.selected = false));

    setRecordings(recordings);
  }
};
